<template>
  <div class="followUp-iframe">
    <div ref="iframeBox" class="iframe">
      <Iframe :src="src" :origin="origin" :ucPatientId="ucUserId" :workOrderId="`${workOrderId}`">
        <template #loading>
          <div class="custom-loading">
            <a-spin />
            正在加载...
          </div>
        </template>
        <template #error="{ errorMessage, retry }">
          <div>{{ errorMessage }}</div>
          <ErrorDisplay :errorMessage="errorMessage" @handleRetry="retry" />
        </template>
      </Iframe>
      <div v-if="mode !== 'read'" @click="toggleFullscreen" class="fullscreen">
        <template v-if="isFullscreen">
          <img :src="exitFullscreenUrl" alt="" />
        </template>
        <template v-else>
          <img :src="fullscreenUrl" alt="" />
        </template>
      </div>
    </div>
    <div v-if="mode !== 'read'" class="info-box">
      <Info ref="infoRef" :loading="spinning" v-bind="$attrs" :ifFollowUp="true" />
    </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted, onUnmounted, ref } from 'vue'
import Iframe from './components/IframeContainer.vue'
import ErrorDisplay from './components/ErrorDisplay.vue'
import Info from '@/views/WorkPlace/Container/chat/components/rightInfo/index.vue'
import exitFullscreenUrl from '@/assets/img/followup/fullscreenExitOutlined.png'
import fullscreenUrl from '@/assets/img/followup/fullscreenOutlined.png'
import {
  CLOSE_CURRENT_IM,
  FINISH_ORDER,
  INIT_ORDER_SORT_STATUS,
  REFRESH_LIST,
  REFRESH_MAIN
} from '@/views/WorkPlace/handleEventBuss'
import getCurrentGroupInfo from '@/views/hooks/getCurrentGroupInfo'
const props = defineProps({
  origin: {
    type: String,
    default: null
  },
  ucUserId: {
    type: String,
    default: null
  },
  mode: {
    type: String,
    default: null
  },
  workOrderId: {
    type: String,
    default: null
  }
})
const iframeBox = ref(null)
const isFullscreen = ref(false)
const spinning = ref(false)
// 切换全屏状态
const toggleFullscreen = () => {
  isFullscreen.value = !isFullscreen.value
  if (!document.fullscreenElement) {
    iframeBox.value?.requestFullscreen()
  } else {
    document.exitFullscreen()
  }
}

const finishChat = () => {
  REFRESH_LIST?.emit()
  CLOSE_CURRENT_IM?.emit()
  INIT_ORDER_SORT_STATUS?.emit()
}

const handleRefresh = () => {
  spinning.value = true
  getCurrentGroupInfo()
    .then(res => {
      const dealWorkOrderList = res?.workOrderGroupInfo?.dealWorkOrderList || []
      if (!dealWorkOrderList.length) {
        CLOSE_CURRENT_IM?.emit()
        return
      }
      spinning.value = false
    })
    .catch(() => {
      spinning.value = false
    })
}

onMounted(() => {
  FINISH_ORDER?.on(finishChat)
  REFRESH_MAIN?.on(handleRefresh)
})

onUnmounted(() => {
  FINISH_ORDER?.off()
  REFRESH_MAIN?.off()
})
</script>

<style scoped lang="scss">
.followUp-iframe {
  height: 100%;
  display: flex;
  overflow: hidden !important;
  .iframe {
    height: 100%;
    flex: 1;
    position: relative;
    .fullscreen {
      position: absolute;
      right: 50px;
      bottom: 150px;
      z-index: 999;
      cursor: pointer;
      width: 40px;
      height: 40px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .info-box {
    width: 400px;
    height: 100%;
    overflow: auto;
    background-color: #fff;
  }
}
</style>
